import { configureStore } from "@reduxjs/toolkit";
import jobReducer from './jobReqSlice'


export const store = configureStore({
    reducer : {
       jobs : jobReducer
    },
})